import React from 'react';
import Button from '@amzn/awsui-components-core/button';
import Popover from '@amzn/awsui-components-core/popover';
import type { StudioOption } from 'src/components/star-grid/reportStudio.types';
import { useStudioCompareMenu } from 'src/components/star-grid/hooks/useStudioCompareMenu';
import styles from 'src/components/star-grid/components/styles/ReportStudio.module.scss';
interface Props {
  readonly label: string;
  readonly closeLabel: string;
  readonly options: readonly StudioOption[];
  readonly testId: string;
  readonly onSelect: (id: string) => void;
}
export const StudioCompareMenu: React.FC<Props> = ({ label, closeLabel, options, testId, onSelect }) => {
  const menu = useStudioCompareMenu(onSelect);
  return (
    <div ref={menu.triggerRef} className={styles.compareTrigger}>
      <Popover
        ref={menu.popoverRef}
        position="bottom"
        size="small"
        fixedWidth
        triggerType="custom"
        renderWithPortal
        dismissAriaLabel={closeLabel}
        dismissButton={false}
        content={
          <div className={styles.compareMenu} data-testid={`${testId}-options`} aria-label={label}>
            {options.map((option) => (
              <Button key={option.id} variant="inline-link" nativeButtonAttributes={{ title: option.label }} onClick={() => menu.select(option.id)}>
                {option.label}
              </Button>
            ))}
          </div>
        }
      >
        <Button variant="inline-link" data-testid={testId} iconName="angle-down" iconAlign="right" onClick={menu.reveal}>
          {label}
        </Button>
      </Popover>
    </div>
  );
};
